const { useEffect, useState } = wp.element;

const Component = ({ department, service, timeslot, setShowConfirmModal, handleConfirmBooking, loadingBooking, additionalServicesData }) => {
    return (
        <div className="overlay-module">
            <div className="container grid">
                <div className="inner">
                    <div className="overlay grid">
                        <svg onClick={() => { setShowConfirmModal(false) }} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_754_12096" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                                <rect width="32" height="32" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_754_12096)">
                                <path d="M8.42541 25L7 23.5746L14.5746 16L7 8.42541L8.42541 7L16 14.5746L23.5746 7L25 8.42541L17.4254 16L25 23.5746L23.5746 25L16 17.4254L8.42541 25Z" fill="#1E1E1E"/>
                            </g>
                        </svg>
                        <div className="text-wrapper">
                            <h3 className="overlay-title">
                                Bekreft
                            </h3>
                            <p className="overlay-text">
                                Vennligst sjekk at bookingen du har valgt stemmer
                            </p>
                            <p className="overlay-detail">
                                LEAN {department?.name}
                                <br/>
                                {service?.name}
                                {
                                    additionalServicesData &&
                                    additionalServicesData.length > 0 &&
                                    <>
                                        <br/>
                                        {
                                            additionalServicesData.map((additionalService, index) => {
                                                return (
                                                    <span key={index}>
                                                        {additionalService?.name}
                                                        {index < additionalServicesData.length - 1 && ', '}
                                                    </span>
                                                )
                                            })
                                        }
                                    </>
                                }
                                <br/>
                                {timeslot?.startLocal && new Date(timeslot?.startLocal).toLocaleDateString('no-NO', { year: '2-digit', month: '2-digit', day: '2-digit' })} kl. {timeslot?.startLocal && new Date(timeslot?.startLocal).toLocaleTimeString('no-NO', { hour: '2-digit', minute: '2-digit' })}
                            </p>
                            <button className="button size--small color--dempet-sort overlay-button" onClick={() => { handleConfirmBooking() }} disabled={loadingBooking}>
                                { loadingBooking ? 'Vennligst vent...' : 'Bekreft time'  }
                            </button>
                            <button className="exit-button link size--small" onClick={() => { setShowConfirmModal(false) }}>
                                Gå tilbake
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Component;